// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2xU0_","content":"GlobalSearch_content__2kuC9"};